import { DeviceType } from "./device";

export enum UPDATE_STATUS {
  STARTED = "STARTED",
  ABORTED = "ABORTED",
  COMPLETE = "COMPLETE",
}

export type UpdateStatus = `${UPDATE_STATUS}`;

export interface Update {
  updateId: string;
  startedAt: string;
  softwareVersion: string;
  deviceType: DeviceType;
  status: UpdateStatus;
  statusAt: number;
  devices: string[];
}

export interface UpdateResponse {
  updateId: string;
  message: string;
  timestamp: number;
}

export interface UpdateStartResponse extends UpdateResponse {
  version: string;
}
